import http from '../../utils/httpService';
import { REGISTER_ROUTE } from './constants';

const registerAccount = form => (
    http.request(REGISTER_ROUTE, 'POST', form)
);

export {
    registerAccount
};